import { ILLBusinessCategory } from '.';

export class ICompanyDetail {
    companyId: string;
    companyRevisionId: string;
    companyName: string;
    businessCategory: ILLBusinessCategory;
    businessCategoryId: string;
    address: string;
    city: string;
    countryId: string;
    countryRegion: string;
    zip: string;
    duns: string;
    fei: string;
    isRegistrantConfidentiality: string;
    isEstablishmentConfidentality: string;
    establishmentOwner: string;
    thirdPartyEstablishment: string;
    labeler: string;
    registrant: string;
    usAgent: string;
    importer: string;
    parentVersion: string;
    userID: string;
    formActiveFlag: string;
    version: string;
    status: string;
    activeFlagFormatted: string;
    activeFlag: string;
    isDraftMode: boolean;
    contactRevisionId: string;
    contactName: string;
    phone: string;
    email: string;
    ndcCodeList: string;
}
